import React from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Typography, Box, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import color from "../../../../../constants/color";
import styles from "./style";
import { formatDate } from "../../../../../utils/DateFormat";

const EmployeeList = ({ taxyearList, isNavigationDisabled }) => {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    if (isNavigationDisabled) return;
    navigate("/dashboard/salaryManagement", { state: { item } });

  }

  return (
    <>
      <TableContainer sx={styles.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={styles.tableHead}>Months</TableCell>
              <TableCell sx={styles.tableHead}>Total Payslips</TableCell>
              <TableCell sx={styles.tableHead}>Total NetPay</TableCell>
              <TableCell sx={styles.tableHead}>Start Date</TableCell>
              <TableCell sx={styles.tableHead}>End Date </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {taxyearList?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              taxyearList?.map((item, index) => (
                <TableRow key={index} sx={{ "&:hover": { backgroundColor: isNavigationDisabled ? "transparent" : "rgba(40, 170, 74, 0.12)", cursor: isNavigationDisabled ? "not-allowed" : "pointer" }, }} onClick={() => handleNavigate(item)}>
                  <TableCell sx={styles.profileData}>
                    <Box style={{ color: color.text, textDecoration: "none", display: "flex", flexDirection: "row" }}>
                      <Box style={{ cursor: "pointer" }}>
                        <Typography sx={styles.name}>{item?.month}</Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tableData}>{item?.totalPayslips}</TableCell>
                  <TableCell sx={styles.tableData}>{item?.totalNetPay}</TableCell>
                  <TableCell sx={styles.tableData}>{formatDate(item?.startDate)}</TableCell>
                  <TableCell sx={styles.tableData}>{formatDate(item?.endDate)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
export default EmployeeList;
